import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'
import { filterDOMProps } from '@react-aria/utils'

export const MetaBrand = forwardRef<SVGSVGElement, IconProps>(({ size = 20, ...rest }, forwardedRef) => {
  const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
      {...domProps}
    >
      <path
        d="M2.88989 11.9372C2.88989 12.6354 3.04191 13.1715 3.24061 13.4959C3.50112 13.9207 3.88969 14.1006 4.28582 14.1006C4.79676 14.1006 5.26417 13.9728 6.16494 12.7168C6.88656 11.7101 7.73686 10.297 8.30898 9.41117L9.27787 7.91033C9.95092 6.86801 10.7299 5.70932 11.6231 4.92392C12.3523 4.28289 13.1389 3.92676 13.9306 3.92676C15.2596 3.92676 16.5256 4.70325 17.4945 6.15957C18.5549 7.75452 19.0696 9.76348 19.0696 11.8367C19.0696 13.0691 18.8286 13.9747 18.4186 14.6902C18.0225 15.3821 17.2504 16.0734 15.9516 16.0734V14.1006C17.0637 14.1006 17.3412 13.0704 17.3412 11.8914C17.3412 10.2112 16.9527 8.34659 16.0967 7.01428C15.4892 6.06926 14.702 5.49182 13.8359 5.49182C12.8992 5.49182 12.1454 6.20409 11.2983 7.47407C10.8479 8.14881 10.3855 8.97109 9.86639 9.89894L9.2949 10.9196C8.14687 12.9718 7.85608 13.4393 7.28206 14.2107C6.27595 15.5614 5.41682 16.0734 4.28582 16.0734C2.94414 16.0734 2.09573 15.4876 1.57028 14.6049C1.14135 13.8857 0.930664 12.9419 0.930664 11.8666L2.88989 11.9372Z"
        fill="#0081FB"
      />
      <path
        d="M2.47534 6.29884C3.37358 4.90294 4.66985 3.92676 6.15662 3.92676C7.01764 3.92676 7.87362 4.18368 8.76744 4.91947C9.74516 5.72395 10.7872 7.04862 12.0873 9.23183L12.5534 10.0153C13.6788 11.9054 14.319 12.8777 14.6937 13.3362C15.1756 13.9251 15.5131 14.1006 15.9515 14.1006C17.0636 14.1006 17.3411 13.0704 17.3411 11.8914L19.0695 11.8367C19.0695 13.0691 18.8285 13.9747 18.4185 14.6902C18.0224 15.3821 17.2503 16.0734 15.9515 16.0734C15.1441 16.0734 14.4288 15.8966 13.6378 15.1442C13.0297 14.5668 12.3188 13.541 11.7719 12.6189L10.1451 9.87923C9.32885 8.50431 8.5801 7.47916 8.14675 7.01492C7.6806 6.5157 7.08135 5.91282 6.12508 5.91282C5.3511 5.91282 4.69382 6.46037 4.14377 7.29791L2.47534 6.29884Z"
        fill="url(#paint0_linear_3450_218)"
      />
      <path
        d="M6.1252 5.91282C5.35122 5.91282 4.69394 6.46037 4.14389 7.29791C3.36613 8.48141 2.88989 10.2443 2.88989 11.9372C2.88989 12.6354 3.04191 13.1715 3.24061 13.4959L1.57028 14.605C1.14135 13.8857 0.930664 12.9419 0.930664 11.8666C0.930664 9.91102 1.46305 7.87281 2.47546 6.29884C3.3737 4.90294 4.66997 3.92676 6.15674 3.92676L6.1252 5.91282Z"
        fill="url(#paint1_linear_3450_218)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3450_218"
          x1="4.77835"
          y1="11.3673"
          x2="17.2684"
          y2="11.993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3450_218"
          x1="3.76921"
          y1="12.7664"
          x2="3.76921"
          y2="8.12401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default MetaBrand
